import { render, staticRenderFns } from "./ComparisonTableRow.vue?vue&type=template&id=784208e4&scoped=true&"
import script from "./ComparisonTableRow.vue?vue&type=script&lang=js&"
export * from "./ComparisonTableRow.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonTableRow.vue?vue&type=style&index=0&id=784208e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784208e4",
  null
  
)

export default component.exports